import { DirectorBase } from '@commenda/types/src/incorporation/types';
import { LegacyDocumentType } from '@prisma/client';
import { passportInfoSchema, personalDetailsSchema } from './schema';

const validatePersonalInfo = (personData: DirectorBase) => {
  try {
    const validationResult = personalDetailsSchema.parse(personData);
    return { success: true };
  } catch (err) {
    return { success: false };
  }
};

const validatePassportInfo = (personData: DirectorBase) => {
  // Validate the personal details
  let validationResult;
  try {
    validationResult = passportInfoSchema.shape.personalDetails.parse(
      personData.personalDetails
    );
  } catch (err) {
    return { success: false };
  }

  //Validate Passport
  const passport = personData.directorFiles.find(
    (eachFile) => eachFile.documentType === LegacyDocumentType.Passport
  );

  return {
    success: !!passport?.id,
  };
};

const validateDocumentInfo = (personData: DirectorBase) => {
  // Validate Emirates ID
  const emiratesId = personData.directorFiles.find(
    (eachFile) => eachFile.documentType === LegacyDocumentType.EmiratesId
  );

  // Validate Visa
  const visa = personData.directorFiles.find(
    (eachFile) => eachFile.documentType === LegacyDocumentType.Visa
  );

  // Validate Address Proof
  const addressProof = personData.addressProof;

  return {
    success: !!(emiratesId?.id && addressProof?.id && visa?.id),
  };
};

export const validateIndividualDirector = (personData: DirectorBase) => {
  const validatePersonalInfoResult = validatePersonalInfo(personData);
  const validatePassportInfoResult = validatePassportInfo(personData);
  const validateDocumentInfoResult = validateDocumentInfo(personData);

  return {
    success:
      validatePersonalInfoResult.success &&
      validatePassportInfoResult.success &&
      validateDocumentInfoResult.success,
  };
};
